import { DocumentType } from '@synergy/models';

/**
 * What one conversion produced.
 *
 * Converting into several documents fires one call per target, one after the
 * other. Until now every step threw its answer away — the thunks dispatched the
 * new documents into the store and returned nothing — so the screen could
 * neither name what it had made nor say which of the calls had failed. It
 * redirected to a list and left the reader to find out.
 */
export interface CreatedDocument {
    type: DocumentType;
    id: number;
    number?: number | string | null;
}

export interface ConvertOutcome {
    created: CreatedDocument[];
    /** True when the call came back with an error; `created` is then empty. */
    failed: boolean;
}

export const NOTHING_CREATED: ConvertOutcome = { created: [], failed: true };
